export default __webpack_public_path__ + "static/5-aaf546cc74853e6b4428754c1602f177.jpeg";